import { sendClickEvent } from './sendClickEvent';
import { sendPageDataEvent } from './sendPageDataEvent';
import { sendImpressions } from './sendImpressions';
export default {
  sendClickEvent: sendClickEvent,
  sendPageDataEvent: sendPageDataEvent,
  sendImpressions: sendImpressions
};